import { Component, Input, ViewChild } from '@angular/core';
import { NavController, ModalController, NavParams, Platform, App, AlertController, MenuController, Content } from 'ionic-angular';
import { SharedService, login, ConfigService, gametype, ThirdPartyService, thirdparty, Sportshome, SportsHomeService, SportsFilterService, BannerSharedService, LottoBetpanelService, SportBetPanelService, SessionService, User, globalData, VirtualBetPanelService, EventListingService } from 'baseline-lib';
import { Global } from '../../../global/global';
import { LoginModalPage } from '../../shared/login-modal/login-modal';
import { WebviewpagesPage } from '../../shared/webviewpages/webviewpages';
import { CustomToast } from '../../shared/services/custom-toast';
import { LoadingController } from 'ionic-angular';
import { SportsMenuPage } from '../../sports/sports-menu-page/sports-menu-page';
import { SportsBetslipPage } from '../../sports/sports-betslip/sports-betslip';
import { BalanceModalPage } from '../../shared/balance-modal/balance-modal';
import { RegisterModalPage } from '../../shared/register-modal/register-modal';
import { TranslateService } from '@ngx-translate/core';
import { VirtualBetslipPage } from '../../virtual-sports/virtual-bet-slip/virtual-betslip';
import { ThirdpartywebpopupPage } from '../../shared/thirdpartywebpopup/thirdpartywebpopup';
import { BetslipPage } from '../../lottery/betslip/betslip';
import { LotteryMenuComponent } from '../../lottery/lottery-menu/lottery-menu';

declare function loadGlobal(url): any;
@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage {
  @ViewChild(Content) content: Content;
  mainMenu: string;
  mainTabMenu: string;
  loginModel: login;
  @Input() appType;
  unautherisedStatus: any;
  httplink: string;
  gameTypeList: gametype[] = [];
  public _imageUrl: string;
  selectedMenu: gametype;
  homeMenu: gametype;
  dataForMenu: string;
  platform: Platform;
  alert: any;
  sportsHomeObj: Sportshome;
  currencySymbol: string;
  showFreeBet: boolean;
  // loadsportsfilter : boolean = false;
  pageFrom: any;
  navsportsData: any;
  navlivesportsdata: any;
  navVirtualSportsData: any;
  navGameId: any;
  reloadsportsfilter: boolean = false;
  selectedTabIndex: number = 0;
  defaultsubmenu: any;
  lotterysubmenu: any;
  submenuposition = 100;
  showsportsfulldetail: boolean = false;
  fullsportdetailObj: any;
  reloadDashboard: boolean = false;
  currency: any;
  tabindex:any;
  constructor(public navCtrl: NavController, public toast: CustomToast,
    public _sharedService: SharedService, private _configService: ConfigService,
    public globalData: Global, public modalCtrl: ModalController,
    public navParams: NavParams, public _platform: Platform,
    public loadingCtrl: LoadingController, public menuCtrl: MenuController,
    public app: App, public alertCtrl: AlertController,
    public _bannerSharedService: BannerSharedService, public _sessionService: SessionService,
    public _thirdPartyService: ThirdPartyService, public _sportsHomeService: SportsHomeService,
    public _sportsFilterService: SportsFilterService, public translate: TranslateService,
    public _lottoBetpanelService: LottoBetpanelService, public _sportsBetpanelServices: SportBetPanelService,
    public _virtualbetpanelservice: VirtualBetPanelService, public _eventListingService: EventListingService) {
    this._sharedService.getLanguageList().subscribe(data => {
      if (data.lli)
        this._sharedService.languageList = data.lli;
    });

    //clear timer to avoid reintialiase timersub
    if (this._sharedService.timerSub) {
      this._sharedService.timerSub.unsubscribe();
    }

    this.currencySymbol = this._sharedService._sessionService.getCurrenySymbol();
    if (this.globalData.isLoggedIn) {
      this.currency = this._sharedService._sessionService.getAuthUser().balance;
    }
    // this.currency=this.globalData.balance
    console.log("currency", this.currency);

    // this.mainMenu = "4";
    // this.globalData.selectedMenu = 'sports';
    // this.globalData.selectedGameId = 4;
    // this._imageUrl = this._configService.getImageUrl();
    // this.selectedMenu = new gametype();
    // this.homeMenu = new gametype();
    // this.homeMenu.gtn = "sports";
    // this.homeMenu.sumbenu =[];
    // this.selectedMenu = this.homeMenu;
    this.platform = _platform;
    this.dataForMenu = this.navParams.get('Menu');
    console.log("menu", this.dataForMenu);

    if (this.dataForMenu == "lottery") {
      this.mainMenu = "1";
      console.log("menu", this.mainMenu);

    }
    this.sportsHomeObj = new Sportshome();

    // this.selectedMenu = menu;
    // this.mainMenu = menu.gtid;
    // this.globalData.selectedMenu = menu.gtn;
    // this.globalData.selectedGameId = menu.gtid;


    this.initialise();
  }

  ngOnInit() {
    console.log("menu", this.mainMenu);

    this._sportsHomeService.setSportsGame();
    this.sportsHomeObj = this._sportsHomeService.sportshomeobj;
    this.loginModel = new login('', '', this._configService.isplayerLogin(), '');

    //  let loader = this.loadingCtrl.create({
    //     content: "Please Wait",
    //   });

    this._sharedService.getGameTypeList().subscribe(
      data => {
        if (data.gameTypeList) {
          this._sharedService.globalData = new globalData(data);
          console.log(data.gameTypeList);

          let pgt: number[] = [];

          if (this.globalData.gameMode == 'lottery')
            pgt = this._configService.getPrimaryGameType();
          else if (this.globalData.gameMode == 'sports')
            pgt = this._configService.getSportsGameType();

          data.gameTypeList.forEach(item => {
            var _gametype = new gametype();
            _gametype.parse(item);
            if (pgt && pgt.length > 0 && pgt.includes(_gametype.gtid)) {

              _gametype.gtn = _gametype.gtn.toLowerCase();
              _gametype.sumbenu.forEach(submenu => {
                submenu.name = submenu.name.toLowerCase();
              });
              this.gameTypeList.push(_gametype);
            }
          });
        }
        // this.menuClicked(this.gameTypeList[0],0);
        var gameonload = this._configService.getGameOnLoad();
        this.gameTypeList.forEach((item, index) => {
          if (item.gtid == +gameonload) {
            this.selectedTabIndex = index;
            this.defaultsubmenu = item;
          }
          if (item.gtid == 1) {
             this.lotterysubmenu = item;
            this.tabindex = index; }
        });

        if (!this.defaultsubmenu) {
          this.selectedTabIndex = 0;
          this.defaultsubmenu = this.gameTypeList[0];
        }
        if (this.dataForMenu == "lottery") {
          this.selectedTabIndex = this.tabindex;
           this.mainMenu = this.lotterysubmenu.gtid;
          this.globalData.selectedMenu = this.lotterysubmenu.gtn;
          this.globalData.selectedGameId = this.lotterysubmenu.gtid;
          this._imageUrl = this._configService.getImageUrl();
          this.selectedMenu = this.lotterysubmenu;
        } else {
          this.setdefaulttab();

        }

        // this.selectedMenu = this.gameTypeList[0];
        // loader.dismiss();
      },
      err => {
        // loader.dismiss();
        console.log('error while server get time.');
        //this.toast.showError("SERVER ERROR......!");
      }
    );
    console.log("menu", this.mainMenu);

  }

  setdefaulttab() {

    this.mainMenu = this.defaultsubmenu.gtid;
    this.globalData.selectedMenu = this.defaultsubmenu.gtn;
    this.globalData.selectedGameId = this.defaultsubmenu.gtid;
    this._imageUrl = this._configService.getImageUrl();
    this.selectedMenu = this.defaultsubmenu;

  }

  evevntclicked(dataObj: any) {
    this.navsportsData = dataObj;
    this.mainMenu = "4";
    this.reloadsportsfilter = true;
    setTimeout(() => {
      this.reloadsportsfilter = false;
    }, 400);
    // this.loadsportsfilter = true;
    this.menuCtrl.close();
    this.showsportsfulldetail = false;
  }

  liveeventclicked(dataObj: any) {
    this.navlivesportsdata = dataObj;
    if (this.navlivesportsdata[2] && this.navlivesportsdata[2] == "categoryclicked") {
      this.reloadsportsfilter = true;
      setTimeout(() => {
        this.reloadsportsfilter = false;
      }, 400);
    }
    this.menuCtrl.close();
    this.mainMenu = "96";
    this.showsportsfulldetail = false;
  }

  backbtnclicked() {
    this.showsportsfulldetail = false;
  }

  loadsportsfulldetail(obj: any) {
    this.fullsportdetailObj = obj;
    this.showsportsfulldetail = true;
    this.mainMenu = "4";
  }
  eventClickedVirtualSports(dataObj: any) {
    this.navVirtualSportsData = dataObj;
    this.mainMenu = "2";
    this.menuCtrl.close();
  }

  eventClickedLottery(_gameid: number) {
    this.navGameId = _gameid;
    this.mainMenu = "1";
    this.menuCtrl.close();
  }

  drawerClicked() {
    // this.menuCtrl.open();
    this.menuCtrl.enable(true);
    this.menuCtrl.toggle();
  }
  changeLanguage() {
    this._sharedService.changeLanguage();
  }

  logo_click() {
    // this.reloadDashboard = true;
    // this.globalData.hideHomeLoader = true;
    this.navCtrl.setRoot(HomePage);
    // setTimeout(() => {
    // this.globalData.hideHomeLoader = false;
    // this.app.getRootNav().setRoot(HomePage);
    // }
    // , 1500);

  }

  initialise() {
    this.platform.registerBackButtonAction(() => {

      let activeNav = this.app.getActiveNav();

      if (activeNav.canGoBack()) {
        this.navCtrl.pop();

      } else {
        if (!this.alert && this.alert == undefined) {
          this.alert = this.alertCtrl.create({
            title: 'Exit?',
            message: 'Do you want to exit from app?',
            cssClass: 'alertCustomCss',
            buttons: [
              {
                text: 'No',
                role: 'cancel',
                handler: () => {
                  console.log('Cancel clicked');
                  this.alert = undefined;
                }
              },
              {
                text: 'Yes',
                handler: () => {
                  console.log('Buy clicked');
                  this.platform.exitApp();
                }
              }
            ]
          });

          this.alert.present();
        }
      }
    })
  }

  loginClicked() {
    let profileModal = this.modalCtrl.create(LoginModalPage);
    profileModal.present();
  }

  registerClicked() {
    let registerModal = this.modalCtrl.create(RegisterModalPage);
    registerModal.present();
  }

  open_balance_modal() {
    let balanceModal = this.modalCtrl.create(BalanceModalPage);
    balanceModal.present();
  }

  profileClicked() {
    this.mainTabMenu = this.mainMenu;
    this.mainMenu = "profile";
    this.content.resize();
  }


  // historyClicked() {
  //   this.menuCtrl.close();
  //   if (parseInt(this.mainMenu) > 0)
  //     this.mainTabMenu = this.mainMenu;
  //   this.mainMenu = "history";
  //   this.content.resize();
  // }

  jackpotClicked() {
    this.mainTabMenu = this.mainMenu;
    this.mainMenu = "jackpot"
    this.content.resize();
  }

  menuClicked(menu, index) {
    this.mainTabMenu = undefined;
    this.navsportsData = undefined;
    this.navGameId = undefined;
    this.navlivesportsdata = undefined;
    this.selectedTabIndex = index;
    this.submenuposition = 100;

    // let loader = this.loadingCtrl.create({
    //   content: "Please Wait",
    // });

    if (menu.gtn == "global bet" || menu.gtn == "live casino") {
      this.mainMenu = menu.gtid;
      this.globalData.selectedGameId = menu.gtid;
      // this.selectedMenu = menu;
      // this.globalData.selectedGameId = menu.gtid;
      // this.globalData.selectedMenu = menu.gtn;
    } else if (menu.gtn == this.defaultsubmenu.gtn) {  // check default selected
      //  setTimeout(() => {
      // this.navsportsData = undefined;

      // this.mainMenu = "0";
      this.setdefaulttab();
      // }
      // , 500);

      // this.logo_click();
    }
    else {
      this.selectedMenu = menu;
      this.mainMenu = menu.gtid;
      this.globalData.selectedMenu = menu.gtn;
      this.globalData.selectedGameId = menu.gtid;
      if (this.selectedMenu.gtid == 7) { // Lottorace
        this.displayLottorace();
      }
    }
    // loader.dismiss();
    this.content.resize();
    this.showsportsfulldetail = false;
    this.reloadsportsfilter = false;
  }

  subMenuClicked(submenu, position) {
    this.submenuposition = position;
    if (parseInt(this.mainMenu) > 0)
      this.mainTabMenu = this.mainMenu;

    if (submenu.name == "help") {
      this.httplink = this._configService.getSupport();
      let profileModal = this.modalCtrl.create(WebviewpagesPage, { url: this.httplink });
      profileModal.present();
    } else if (submenu.name == "livescores") {
      //this.httplink = this._configService.getLiveScores();
      this.httplink = submenu.spec.rdurl + "/" + this._sharedService.selectedLanguage;
      // let profileModal = this.modalCtrl.create(WebviewpagesPage, { url: this.httplink });
      // profileModal.present();
      this.navCtrl.push(ThirdpartywebpopupPage, { url: this.httplink });
    } else if (submenu.name == "statistics") {
      //this.httplink = this._configService.getStatistics();
      this.httplink = submenu.spec.rdurl + "/" + this._sharedService.selectedLanguage;
      // let profileModal = this.modalCtrl.create(WebviewpagesPage, { url: this.httplink });
      // profileModal.present();
      this.navCtrl.push(ThirdpartywebpopupPage, { url: this.httplink });

    } else if (submenu.name == "sunday raffle") {
      let tempurl = submenu.url.split("/");
      this.globalData.sundaybaffleid = tempurl[4];
      this.mainMenu = submenu.name;
    } else {
      this.mainMenu = submenu.name;
    }
    this.menuCtrl.close();
    this.content.resize();
  }


  gameModeChange(gameMode) {
    if (this._configService.getSportsGameType().length > 0) {
      if (gameMode == 'lottery')
        this.globalData.gameMode = 'sports';
      else if (gameMode == 'sports')
        this.globalData.gameMode = 'lottery';

      this.navCtrl.setRoot(this.navCtrl.getActive().component);
    }
  }

  displayLottorace() {
    this._thirdPartyService.evaluateThirdPartyGame(this.globalData.selectedGameId).subscribe(
      data => {
        if (data) {
          this.httplink = this._thirdPartyService.selectedGame.bindingUrl;
          let profileModal = this.modalCtrl.create(WebviewpagesPage, { url: this.httplink });
          profileModal.present();

          // Load Home Page
          // this.mainMenu = "home";
          // this.globalData.selectedMenu = 'home';
          // this.globalData.selectedGameId = 0;
          // this.selectedMenu = new gametype();
          // this.homeMenu = new gametype();
          // this.homeMenu.gtn = "home";
          // this.homeMenu.sumbenu =[];
          // this.selectedMenu = this.homeMenu;
          // this.dataForMenu = this.navParams.get('Menu');   
          // this.initialise();

          this.dataForMenu = this.navParams.get('Menu');
          // this.mainMenu = "4";
          // this.globalData.selectedMenu = 'sports';
          // this.globalData.selectedGameId = 4;
          this.setdefaulttab();

          this.initialise();


        }
      });
  }


  openSportsMenuPage() {
    this.navCtrl.push(SportsMenuPage);
  }

  openBetSlipPage() {
    if (this.mainMenu == "2") {
      this.navCtrl.push(VirtualBetslipPage);

    }
    if (this.mainMenu == "4" || this.mainMenu == "96") {
      this.navCtrl.push(SportsBetslipPage);

    }
    if (this.mainMenu == "1") {
      this.navCtrl.push(BetslipPage);

    }

  }
}



// WEBPACK FOOTER //
// ./src/app/home/home/home.ts